"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkEditMenu = exports.dispatchBulkEditField = exports.emptyChoice = exports.RowSelectorHeader = exports.RowSelectorCell = void 0;
var columns_1 = require("./columns");
var React = require("react");
var buttons_1 = require("../buttons");
var generic_1 = require("../generic");
var App_1 = require("../../App");
var userSuggest_1 = require("../lib/userSuggest");
var relations_1 = require("./relations");
var mobx_react_1 = require("mobx-react");
var config_1 = require("../../config");
var multiSelect_1 = require("../lib/multiSelect");
var iterUtils_1 = require("../lib/iterUtils");
var editableCell_1 = require("./editableCell");
var react_datepicker_1 = require("react-datepicker");
var moment = require("moment");
var api_1 = require("../../api");
var combobox_1 = require("../lib/combobox");
var controls_1 = require("../../interfaces/controls");
var discardRecurrenceDialog_1 = require("../controls/discardRecurrenceDialog");
var RowSelectorCell = (function (_super) {
    __extends(RowSelectorCell, _super);
    function RowSelectorCell() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.column = new columns_1.RowSelectorColumn();
        return _this;
    }
    RowSelectorCell.prototype.onInputChange = function (e) {
        this.props.onChange(this.props.row, e.target.checked);
    };
    RowSelectorCell.prototype.render = function () {
        return (React.createElement("td", { className: this.column.get_field_class() },
            React.createElement("input", { type: "checkbox", value: this.props.row.id, checked: this.props.isRowSelected(this.props.row), onChange: this.onInputChange.bind(this) })));
    };
    return RowSelectorCell;
}(React.Component));
exports.RowSelectorCell = RowSelectorCell;
var rowSelectorColumn = new columns_1.RowSelectorColumn();
var RowSelectorHeader = function (props) {
    return (React.createElement("th", { className: rowSelectorColumn.get_header_class() },
        React.createElement("input", { type: "checkbox", checked: props.areAllChecked(), onChange: props.onClick })));
};
exports.RowSelectorHeader = RowSelectorHeader;
exports.emptyChoice = {
    display_name: '-',
    value: '',
};
var BulkEditSelectField = function (props) {
    var choices = [exports.emptyChoice].concat(props.field.options.map(function (c) { return c; }));
    return (React.createElement("div", null,
        React.createElement("p", null,
            props.field.display,
            ":"),
        React.createElement(generic_1.ChoiceSelect, { choices: choices, value: null, onChange: function (event) {
                var selected = event.target.options[event.target.selectedIndex];
                props.onChangeHandler(props.field, selected.value);
            } })));
};
var BulkEditAutoSuggestField = (function (_super) {
    __extends(BulkEditAutoSuggestField, _super);
    function BulkEditAutoSuggestField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            value: null
        };
        return _this;
    }
    BulkEditAutoSuggestField.prototype.valueChanged = function (value) {
        this.setState({ value: value });
        this.props.onChangeHandler(this.props.field, value);
    };
    BulkEditAutoSuggestField.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("p", null,
                this.props.field.display,
                ":"),
            React.createElement(combobox_1.ComboBox, { className: "form-control", options: (0, combobox_1.choices_to_suggestions)(this.props.field.options), value: this.state.value, onChange: function (value) { return _this.valueChanged.bind(_this)(value); } })));
    };
    return BulkEditAutoSuggestField;
}(React.Component));
;
var BulkEditTextField = function (props) {
    return (React.createElement("div", null,
        React.createElement("p", null, props.field.display + ":"),
        React.createElement("textarea", { className: "form-control", name: props.field.name, value: null, onChange: function (e) {
                return props.onChangeHandler(props.field, e.target.value);
            } })));
};
var BulkEditFileField = function (props) {
    return (React.createElement("div", null,
        React.createElement("p", null, props.field.display + ":"),
        React.createElement("input", { className: "form-control-file", name: props.field.name, type: 'file', value: null, onChange: function (e) {
                return props.onChangeHandler(props.field, e.target.files[0]);
            } })));
};
var BulkEditPasswordField = function (props) {
    return (React.createElement("div", null,
        React.createElement("p", null, props.field.display + ":"),
        React.createElement("input", { className: "form-control", name: props.field.name, type: 'password', value: null, onChange: function (e) {
                return props.onChangeHandler(props.field, e.target.value);
            } })));
};
var BulkEditBooleanField = function (props) {
    return (React.createElement("div", null,
        React.createElement("p", null, props.field.display + ":"),
        React.createElement("input", { type: "checkbox", name: props.field.name, onChange: function (e) {
                return props.onChangeHandler(props.field, e.currentTarget.checked);
            } })));
};
var BulkEditNumberField = function (props) {
    return (React.createElement("div", null,
        React.createElement("p", null, props.field.display + ":"),
        React.createElement("input", { type: "number", pattern: "[0-9]*", value: null, className: "form-control", onChange: function (e) {
                return props.onChangeHandler(props.field, e.target.value);
            } })));
};
var BulkEditUserField = function (props) {
    return (React.createElement("div", null,
        React.createElement("p", null,
            props.field.display,
            ":"),
        React.createElement(userSuggest_1.UserSuggest, { objects: [editableCell_1.noOwner].concat(App_1.store.users.users.map(function (u) { return u; })), onChange: function (id) {
                if (id === null)
                    return;
                if (id === "0")
                    id = null;
                props.onChangeHandler(props.field, id);
            }, focusInputOnSuggestionClick: false })));
};
var BulkEditDateField = (function (_super) {
    __extends(BulkEditDateField, _super);
    function BulkEditDateField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selected: null,
        };
        return _this;
    }
    BulkEditDateField.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var date = null;
        if (moment(this.state.selected).isValid())
            date = moment(this.state.selected);
        return (React.createElement("div", null,
            React.createElement("p", null, props.field.display + ":"),
            React.createElement(react_datepicker_1.default, { selected: date, onChange: function (date) {
                    var newDate = "";
                    if (moment.isMoment(date))
                        newDate = date.format(config_1.ISO_DATE_FORMAT);
                    else
                        newDate = date.toString();
                    _this.setState({ selected: newDate });
                    props.onChangeHandler(props.field, newDate);
                } })));
    };
    return BulkEditDateField;
}(React.Component));
var BulkEditRelationField = (function (_super) {
    __extends(BulkEditRelationField, _super);
    function BulkEditRelationField(props) {
        var _this = _super.call(this, props) || this;
        _this.changeHandler = function (id, checked) {
            var relations = _this.state.relations.slice();
            var relation = null;
            var relationIndex = -1;
            relations.forEach(function (value, index) {
                if (value.id == parseInt(id)) {
                    relation = __assign(__assign({}, value), { checked: checked, indeterminate: false });
                    relationIndex = index;
                }
            });
            relations[relationIndex] = relation;
            _this.setState({
                relations: relations
            });
            _this.prepareParentState(relations, _this.state.objects);
        };
        _this.addRelationHandler = function (id) {
            if (id) {
                var obj_1 = null;
                _this.state.objects.forEach(function (r) {
                    if (r.id == parseInt(id)) {
                        obj_1 = r;
                    }
                });
                var objects = _this.state.objects.filter(function (value) { return value.id !== parseInt(id); });
                var relations = _this.state.relations.slice();
                relations.push({
                    id: obj_1.id,
                    display: _this.getObjectDisplay(obj_1),
                    checked: true,
                    indeterminate: false,
                });
                _this.setState({
                    relations: relations,
                    objects: objects
                });
                _this.prepareParentState(relations, objects);
            }
        };
        _this.prepareParentState = function (relations, objects) {
            var checked = relations.filter(function (value) { return value.checked; }).map(function (value) { return value.id.toString(); });
            var unchecked = relations.filter(function (value) { return !value.checked && !value.indeterminate; }).map(function (value) { return value.id.toString(); });
            _this.props.onChangeHandler(_this.props.field, checked);
            _this.props.onChangeHandler(_this.props.removeField, unchecked);
        };
        _this.state = {
            relations: _this.props.relations || [],
            objects: _this.props.objects || []
        };
        return _this;
    }
    BulkEditRelationField.prototype.getObjectDisplay = function (obj) {
        throw new Error("Method not implemented");
    };
    BulkEditRelationField.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (!(0, iterUtils_1.equalLists)(nextProps.relations, this.props.relations) ||
            !(0, iterUtils_1.equalLists)(nextProps.objects, this.props.objects)) {
            this.setState({
                relations: nextProps.relations,
                objects: nextProps.objects
            });
            this.prepareParentState(nextProps.relations, nextProps.objects);
        }
    };
    BulkEditRelationField.prototype.render = function () {
        var _this = this;
        var objects = this.state.objects.map(function (obj) {
            return {
                id: obj.id,
                display: _this.getObjectDisplay(obj),
            };
        });
        return (React.createElement("div", null,
            React.createElement("p", null,
                this.props.field.display,
                ":"),
            React.createElement(relations_1.default, { addRelationHandler: this.addRelationHandler, onChangeHandler: this.changeHandler, relations: this.state.relations, objects: objects })));
    };
    return BulkEditRelationField;
}(React.Component));
var BulkEditRiskRelationField = (function (_super) {
    __extends(BulkEditRiskRelationField, _super);
    function BulkEditRiskRelationField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BulkEditRiskRelationField.prototype.getObjectDisplay = function (risk) {
        return "#".concat(risk.risk_number, ": ").concat(risk.title);
    };
    BulkEditRiskRelationField = __decorate([
        mobx_react_1.observer
    ], BulkEditRiskRelationField);
    return BulkEditRiskRelationField;
}(BulkEditRelationField));
var BulkEditCausalityField = (function (_super) {
    __extends(BulkEditCausalityField, _super);
    function BulkEditCausalityField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BulkEditCausalityField.prototype.getObjectDisplay = function (causality) {
        return "#".concat(causality.number, ": ").concat(causality.text);
    };
    BulkEditCausalityField = __decorate([
        mobx_react_1.observer
    ], BulkEditCausalityField);
    return BulkEditCausalityField;
}(BulkEditRelationField));
var BulkEditControlRelationField = (function (_super) {
    __extends(BulkEditControlRelationField, _super);
    function BulkEditControlRelationField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BulkEditControlRelationField.prototype.getObjectDisplay = function (control) {
        return "#".concat(control.control_number, ": ").concat(control.description);
    };
    BulkEditControlRelationField = __decorate([
        mobx_react_1.observer
    ], BulkEditControlRelationField);
    return BulkEditControlRelationField;
}(BulkEditRelationField));
var BulkEditMultiselectField = (function (_super) {
    __extends(BulkEditMultiselectField, _super);
    function BulkEditMultiselectField(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            checked: [],
            unchecked: [],
        };
        return _this;
    }
    BulkEditMultiselectField.prototype.componentWillReceiveProps = function (nextProps) {
        if (!(0, iterUtils_1.equalLists)(this.props.checked_values, nextProps.checked_values) ||
            !(0, iterUtils_1.equalLists)(this.props.unchecked_values, nextProps.unchecked_values)) {
            var checked = nextProps.checked_values.map(function (id) { return id.toString(); });
            var unchecked = nextProps.unchecked_values.map(function (id) { return id.toString(); });
            this.onChange(checked, unchecked);
        }
    };
    BulkEditMultiselectField.prototype.setParentState = function (checked, unchecked) {
        this.props.onChangeHandler(this.props.field, checked);
        this.props.onChangeHandler(this.props.removeField, unchecked);
    };
    BulkEditMultiselectField.prototype.onChange = function (checked, unchecked) {
        this.setParentState(checked, unchecked);
        this.setState(function (prev) {
            return {
                checked: checked,
                unchecked: unchecked,
            };
        });
    };
    BulkEditMultiselectField.prototype.render = function () {
        return (React.createElement(React.Fragment, null,
            this.props.field.name == "userdefined" &&
                React.createElement("p", null, this.props.field.display + ":"),
            React.createElement(multiSelect_1.Multiselect, { choices: this.props.available_choices, value: this.state.checked, unchecked: this.state.unchecked, name: this.props.field.name, enable_indeterminate: true, selectedText: this.props.selectionPlaceholder, noneSelectedText: this.props.defaultPlaceholder, onChange: this.onChange.bind(this), classes: "gm--fullwidth" })));
    };
    BulkEditMultiselectField = __decorate([
        mobx_react_1.observer
    ], BulkEditMultiselectField);
    return BulkEditMultiselectField;
}(React.Component));
function dispatchBulkEditField(field, rowIds, onChangeHandler, updateBulkDialogState, bulkMenuState) {
    if (field.name == "userdefined" && bulkMenuState && updateBulkDialogState) {
        switch (field.type) {
            case columns_1.ColumnTypes.SELECT: {
                return React.createElement(BulkEditSelectField, { field: field, onChangeHandler: onChangeHandler });
            }
            case columns_1.ColumnTypes.AUTOSUGGEST: {
                return React.createElement(BulkEditAutoSuggestField, { field: field, onChangeHandler: onChangeHandler });
            }
            case columns_1.ColumnTypes.TEXT:
                return React.createElement(BulkEditTextField, { field: field, onChangeHandler: onChangeHandler });
            case columns_1.ColumnTypes.NUMBER:
                return React.createElement(BulkEditNumberField, { field: field, onChangeHandler: onChangeHandler });
            case columns_1.ColumnTypes.DATE:
                return React.createElement(BulkEditDateField, { field: field, onChangeHandler: onChangeHandler });
            case columns_1.ColumnTypes.CHECKBOXES: {
                var removeField = {
                    name: "remove_udf_" + field.field_object_id,
                    display: "",
                    type: columns_1.ColumnTypes.CHECKBOXES,
                };
                return React.createElement(BulkEditMultiselectField, { defaultPlaceholder: gettext("Select..."), selectionPlaceholder: gettext(" selected"), field: field, removeField: removeField, available_choices: bulkMenuState.udf_state.available['udf_' + field.field_object_id].map(function (t) {
                        return {
                            display_name: t.display_name,
                            value: t.value,
                        };
                    }), group_choices: true, checked_values: bulkMenuState.udf_state.selected['udf_' + field.field_object_id], unchecked_values: bulkMenuState.udf_state.unselected['udf_' + field.field_object_id], rowIds: rowIds, onChangeHandler: onChangeHandler });
            }
        }
        return;
    }
    switch (field.type) {
        case columns_1.ColumnTypes.SELECT:
            return React.createElement(BulkEditSelectField, { field: field, onChangeHandler: onChangeHandler });
        case columns_1.ColumnTypes.USER:
            return React.createElement(BulkEditUserField, { field: field, onChangeHandler: onChangeHandler });
        case columns_1.ColumnTypes.TEXT:
            return React.createElement(BulkEditTextField, { field: field, onChangeHandler: onChangeHandler });
        case columns_1.ColumnTypes.PASSWORD:
            return React.createElement(BulkEditPasswordField, { field: field, onChangeHandler: onChangeHandler });
        case columns_1.ColumnTypes.DATE:
            return React.createElement(BulkEditDateField, { field: field, onChangeHandler: onChangeHandler });
        case columns_1.ColumnTypes.FILE:
            return React.createElement(BulkEditFileField, { field: field, onChangeHandler: onChangeHandler });
        case columns_1.ColumnTypes.LINKS:
            if (field.name == columns_1.ControlColumnIds.RISK_RELATIONS) {
                var removeField = {
                    name: columns_1.ControlColumnIds.REMOVE_RISK_RELATIONS,
                    display: "",
                    type: columns_1.ColumnTypes.LINKS,
                };
                return React.createElement(BulkEditRiskRelationField, { field: field, removeField: removeField, onChangeHandler: onChangeHandler, objects: bulkMenuState.risks, relations: bulkMenuState.risk_relations });
            }
            else if (field.name == columns_1.RiskColumnIds.CONTROLS) {
                var removeField = {
                    name: columns_1.RiskColumnIds.REMOVE_CONTROLS,
                    display: "",
                    type: columns_1.ColumnTypes.LINKS,
                };
                return React.createElement(BulkEditControlRelationField, { field: field, removeField: removeField, onChangeHandler: onChangeHandler, objects: bulkMenuState.controls, relations: bulkMenuState.control_relations });
            }
            else if (field.name == columns_1.CausalityColumnIds.RISK_RELATIONS) {
                var removeField = {
                    name: columns_1.CausalityColumnIds.REMOVE_RISK_RELATIONS,
                    display: "",
                    type: columns_1.ColumnTypes.LINKS,
                };
                return React.createElement(BulkEditRiskRelationField, { field: field, removeField: removeField, onChangeHandler: onChangeHandler, objects: bulkMenuState.risks, relations: bulkMenuState.risk_relations });
            }
            else if (field.name == 'causes') {
                var removeField = {
                    name: "remove_causes",
                    display: "",
                    type: columns_1.ColumnTypes.LINKS,
                };
                return React.createElement(BulkEditCausalityField, { field: field, removeField: removeField, onChangeHandler: onChangeHandler, objects: bulkMenuState.causes, relations: bulkMenuState.cause_relations });
            }
            else if (field.name == 'effects') {
                var removeField = {
                    name: "remove_effects",
                    display: "",
                    type: columns_1.ColumnTypes.LINKS,
                };
                return React.createElement(BulkEditCausalityField, { field: field, removeField: removeField, onChangeHandler: onChangeHandler, objects: bulkMenuState.effects, relations: bulkMenuState.effect_relations });
            }
            break;
        case columns_1.ColumnTypes.CHECKBOXES:
            if (field.name == "tags" && bulkMenuState && updateBulkDialogState) {
                var removeField = {
                    name: "remove_tags",
                    display: "",
                    type: columns_1.ColumnTypes.CHECKBOXES,
                };
                return React.createElement(BulkEditMultiselectField, { defaultPlaceholder: gettext("Select tags"), selectionPlaceholder: gettext("tag(s) selected"), field: field, removeField: removeField, available_choices: bulkMenuState.available_tags.map(function (t) {
                        return {
                            display_name: t.name,
                            value: t.id.toString(),
                            group_name: t.category_name,
                        };
                    }), group_choices: true, checked_values: bulkMenuState.checked_tags, unchecked_values: bulkMenuState.unchecked_tags, rowIds: rowIds, onChangeHandler: onChangeHandler });
            }
            else if (field.name == "groups" && bulkMenuState && updateBulkDialogState) {
                var removeField = {
                    name: "remove_groups",
                    display: "",
                    type: columns_1.ColumnTypes.CHECKBOXES,
                };
                return React.createElement(BulkEditMultiselectField, { defaultPlaceholder: gettext("Select confidentiality"), selectionPlaceholder: gettext("group(s) selected"), field: field, removeField: removeField, available_choices: bulkMenuState.available_groups, checked_values: bulkMenuState.checked_groups, unchecked_values: bulkMenuState.unchecked_groups, rowIds: rowIds, onChangeHandler: onChangeHandler });
            }
            break;
        case columns_1.ColumnTypes.BOOLEAN:
            return React.createElement(BulkEditBooleanField, { field: field, onChangeHandler: onChangeHandler });
        default:
            console.error("Unknown field type in Bulk Edit menu.");
    }
}
exports.dispatchBulkEditField = dispatchBulkEditField;
var BulkEditMenu = (function (_super) {
    __extends(BulkEditMenu, _super);
    function BulkEditMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            valuesByField: {},
            buttonsDisabled: true
        };
        return _this;
    }
    BulkEditMenu.prototype.closeMenu = function () {
        this.setState({ buttonsDisabled: false });
        this.props.toggleEdit();
    };
    ;
    BulkEditMenu.prototype.onUpdateSuccess = function (response, opts) {
        var self = this;
        if (response.confidentiality_warning) {
            optionDialog(response.confidentiality_warning, [{
                    text: gettext("Retain confidentiality"),
                    "class": "btn btn-primary",
                    click: function () { return self.performUpdate(__assign(__assign({}, opts), { ignore_confidentiality_warning: true, retain_confidentiality: true })); }
                }, {
                    text: gettext("Make public"),
                    "class": "btn btn-secondary",
                    click: function () { return self.performUpdate(__assign(__assign({}, opts), { ignore_confidentiality_warning: true, retain_confidentiality: false })); }
                }], function () { return self.setState({ buttonsDisabled: false }); }, null, 500);
        }
        else if (response.close_attached_controls) {
            App_1.store.closeAttachedControlsDialog.controls = response.close_attached_controls;
            var selected_status = this.state.valuesByField.status.toString();
            selectOptionConfirmation({
                header: App_1.store.closeAttachedControlsDialog.title,
                message: App_1.store.closeAttachedControlsDialog.buildMessage(),
                choices: App_1.store.closeAttachedControlsDialog.getChoices(selected_status),
                onSave: function (status) {
                    if ((0, iterUtils_1.contains)(controls_1.ControlStatusChoices.toStringList(), status)) {
                        return App_1.store.closeAttachedControlsDialog
                            .setStatusOnControls
                            .bind(App_1.store.closeAttachedControlsDialog)(status)
                            .then(function () { return self.performUpdate(opts); });
                    }
                    else {
                        return self.performUpdate(__assign(__assign({}, opts), { ignore_control_warning: true }));
                    }
                },
                onClose: function () {
                    App_1.store.closeAttachedControlsDialog.closeDialog
                        .bind(App_1.store.closeAttachedControlsDialog);
                    self.setState({ buttonsDisabled: false });
                }
            });
        }
        else if (response.discard_recurrence) {
            (0, discardRecurrenceDialog_1.discardRecurrenceDialog)({
                msg: response.discard_recurrence,
                onDiscardAll: function () {
                    self.performUpdate(__assign(__assign({}, opts), { remove_recurrence: true, ignore_recurrence_warning: true }));
                },
                onDiscardOne: function () {
                    self.performUpdate(__assign(__assign({}, opts), { remove_recurrence: false, ignore_recurrence_warning: true }));
                },
                width: 500,
            });
        }
        else {
            notification(response.message);
            this.props.refetchTable && this.props.refetchTable();
            this.closeMenu();
        }
    };
    ;
    BulkEditMenu.prototype.onUpdateFailed = function (error) {
        api_1.api.apiErrorHandler(error, null, null);
        this.closeMenu();
    };
    BulkEditMenu.prototype.performUpdate = function (opts) {
        var _this = this;
        if (this.props.performBulkUpdate) {
            this.setState({ buttonsDisabled: true });
            var data = __assign(__assign({}, this.state.valuesByField), { ignore_confidentiality_warning: !!opts.ignore_confidentiality_warning, ignore_control_warning: !!opts.ignore_control_warning, ignore_recurrence_warning: !!opts.ignore_recurrence_warning, remove_recurrence: !!opts.remove_recurrence });
            if (!!opts.ignore_confidentiality_warning)
                data["retain_confidentiality"] = opts.retain_confidentiality !== false;
            this.props.performBulkUpdate(data)
                .then(function (response) { return _this.onUpdateSuccess.bind(_this)(response, opts); }, this.onUpdateFailed.bind(this));
        }
    };
    BulkEditMenu.prototype.updateBulkMenuControls = function (props) {
        var _this = this;
        new Promise(function (resolve, reject) {
            _this.setState({ buttonsDisabled: true });
            resolve(true);
        }).then(function () {
            var promise;
            if (props) {
                promise = _this.props.updateBulkMenuState && _this.props.updateBulkMenuState({
                    selected_row_ids: props.selectedRowIds.map(function (row_id) { return row_id; })
                });
            }
            else {
                promise = _this.props.updateBulkMenuState && _this.props.updateBulkMenuState();
            }
            promise.then(function () {
                _this.setState({ buttonsDisabled: false });
            });
        });
    };
    BulkEditMenu.prototype.componentDidMount = function () {
        this.updateBulkMenuControls();
    };
    BulkEditMenu.prototype.componentWillReceiveProps = function (nextProps, nextContext) {
        if (nextProps.selectedRowIds !== this.props.selectedRowIds) {
            this.updateBulkMenuControls(nextProps);
        }
    };
    BulkEditMenu.prototype.onFieldChange = function (field, value) {
        var _this = this;
        this.setState(function (prevState) {
            var selectedFields = __assign({}, prevState.valuesByField);
            return {
                valuesByField: _this.updateField(selectedFields, field, value),
            };
        });
    };
    BulkEditMenu.prototype.updateField = function (selectedFields, field, value) {
        var name = field.name;
        if (name === 'userdefined')
            name = 'udf_' + field.field_object_id;
        if (name === columns_1.PLayersColumnIds.GAME_STATUS)
            name = 'game_' + field.field_object_id + '_status';
        switch (field.type) {
            case columns_1.ColumnTypes.TEXT:
            case columns_1.ColumnTypes.NUMBER:
            case columns_1.ColumnTypes.DATE:
            case columns_1.ColumnTypes.USER:
            case columns_1.ColumnTypes.BOOLEAN:
            case columns_1.ColumnTypes.AUTOSUGGEST:
            case columns_1.ColumnTypes.FILE:
            case columns_1.ColumnTypes.PASSWORD:
                selectedFields[name] = value;
                break;
            case columns_1.ColumnTypes.SELECT:
                if (value === exports.emptyChoice.value)
                    delete selectedFields[name];
                else
                    selectedFields[name] = value;
                break;
            case columns_1.ColumnTypes.CHECKBOXES:
            case columns_1.ColumnTypes.LINKS:
                if (value === null)
                    delete selectedFields[name];
                else if (value instanceof Array)
                    selectedFields[name] = value;
                else if (typeof value == "string")
                    selectedFields[name] = [value];
                break;
            default:
                console.error("Unknown field type in Bulk Edit menu");
        }
        return selectedFields;
    };
    BulkEditMenu.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var disabled = this.state.buttonsDisabled;
        return (React.createElement("div", { className: "EditableList__BulkEditMenu" },
            React.createElement("h3", null, gettext("Edit Menu")),
            props.fields && props.fields.map(function (field) {
                return dispatchBulkEditField(field, props.selectedRowIds, _this.onFieldChange.bind(_this), _this.props.updateBulkMenuState, _this.props.bulkMenuState);
            }),
            React.createElement("p", null, gettext("Selected rows") + ": " + props.selectedRowIds.length),
            this.props.performBulkUpdate &&
                React.createElement("div", null,
                    React.createElement(buttons_1.PrimaryButton, { onClick: function (e) {
                            _this.performUpdate({});
                        }, className: "mr-1", disabled: disabled },
                        gettext("Update"),
                        " ",
                        disabled &&
                            React.createElement("div", { className: "iconwrapper" },
                                React.createElement("i", { className: "fas fa-spinner fa-spin tabSpinner statusTab" }))),
                    React.createElement(buttons_1.CancelButton, { onClick: function (e) { return props.toggleEdit(); } }, gettext("Cancel")),
                    " ")));
    };
    BulkEditMenu = __decorate([
        mobx_react_1.observer
    ], BulkEditMenu);
    return BulkEditMenu;
}(React.Component));
exports.BulkEditMenu = BulkEditMenu;
